import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetManagementOtherSubjectsOptionsAction} from '../action';

function* execute({payload}: GetManagementOtherSubjectsOptionsAction): SagaIterator {
    const response = yield* call(Api.searchOtherSubjectsForUser, {text: payload});

    if (response.isSuccess) {
        yield* put(adminAction.setManagementOtherSubjectsOptions(response.data.map(o => ({
            value: o.id,
            label: o.otherSubjectName,
        }))));
    } else {
        yield putAll(showBeError(response, t('userDetail')('otherSubjectsLoading')));
    }
}
/** Runs the admin saga that loads other-subject options for the management form. */
export function* getManagementOtherSubjectsOptionsSaga(): SagaIterator {
    yield takeLatestF('admin/GET_MANAGEMENT_OTHER_SUBJECTS_OPTIONS', execute);
}
